export default __webpack_public_path__ + "static/media/grade.94e17b7f.svg";